// store/slices/categoriesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API, categoriesEndpoint } from "../consts/consts";
import { logoutUser } from "./usersSlice";


/* ================= INITIAL STATE ================= */

const initialState = {
  allCategories: [],
  categoriesAdmin: [],
  categoryAdminGet: {},
  loading: false,
  error: null,
}

/* ================= THUNKS ================= */

export const fetchCategories = createAsyncThunk(
  "categories/fetchAll",
  async (token, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${REACT_APP_API}categories`, {
        headers: { "x-access-token": token },
      });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchCategoryAdmin = createAsyncThunk(
  "categories/fetchCateAdmin",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${REACT_APP_API}categories/${id}`, {
        headers: { "x-access-token": token },
      });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const addCategory = createAsyncThunk(
  "categories/add",
  async ({ category, token }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${REACT_APP_API}categories/add`,
        category,
        { headers: { "x-access-token": token } }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);


export const updCategory = createAsyncThunk(
  "categories/update",
  async ({ category, token }, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${REACT_APP_API}categories/update`,
        category,
        { headers: { "x-access-token": token } }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "categories/delete",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      await axios.delete(`${categoriesEndpoint}delete/${id}`, {
        headers: { "x-access-token": token },
      });
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.allCategories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addCategory.pending, (state) => {
        state.loading = true;
      })

      .addCase(addCategory.fulfilled, (state, action) => {
        state.categoriesAdmin.push(action.payload);
        localStorage.setItem("categoryAdded", true);
      })

      .addCase(addCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updCategory.pending, (state) => {
        state.loading = true;
      })

      .addCase(updCategory.fulfilled, (state, action) => {
        state.categoriesAdmin.push(action.payload);
        localStorage.setItem("categoryUpdated", true);
      })

      .addCase(updCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteCategory.pending, (state) => {
        state.loading = true;
      })

      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.allCategories = state.allCategories.filter(
          (c) => c.id !== action.payload
        );
        localStorage.setItem("categoryDeleted", true);
      })

      .addCase(deleteCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        localStorage.setItem("categoryDeleted", action.payload);
      })

      .addCase(fetchCategoryAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoryAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryAdminGet = action.payload;
      })
      .addCase(fetchCategoryAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(logoutUser, () => initialState);
  },
});

export default categoriesSlice.reducer;
